import { render, staticRenderFns } from "./FunEnglish.vue?vue&type=template&id=0badb095&scoped=true"
import script from "./FunEnglish.vue?vue&type=script&lang=js"
export * from "./FunEnglish.vue?vue&type=script&lang=js"
import style0 from "./FunEnglish.vue?vue&type=style&index=0&id=0badb095&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0badb095",
  null
  
)

export default component.exports